import axios from "axios";
import React, { useEffect } from "react";
import { startSessionMonitor, sessionLifecycle } from "./auth/session-lifecycle";
import { SIGNOUT_SUCCESS } from "./redux/constants/Auth";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";
import Views from "./views";
import { Route, Switch } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: (attempt, error) => !axios.isCancel(error) && attempt < 3 } },
});
store.subscribe(() => sessionLifecycle.check());
sessionLifecycle.subscribe(() => {
  queryClient.clear();
  store.dispatch({ type: SIGNOUT_SUCCESS });
});

function App() {
  useEffect(startSessionMonitor, []);
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Router>
            <Switch>
              <Route path="/" component={Views} />
            </Switch>
          </Router>
        </Provider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
